<h3>Programar Férias</h3>
<a href="#" class="sr-only">Programar Férias</a>

<style>
    @media (max-width: 960px) {
        div.p-tooltip-top > div.p-tooltip-text {
            margin-top: -10px !important;
            margin-bottom: -10px !important;
        }
        div.p-tooltip-arrow {
            display: none;
        }
    }
</style>

<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="true" [exibirTipoPeriodoAquisitivo]="false"></app-cabecalho-funcional>
<div class="row">
    <div class="col-sm-12">
        <ng-container *ngFor="let parcela of parcelasFerias; let i = index">
            <h4 style="color: var(--active)">{{ parcela.ordem }}ª Parcela</h4>
            <div class="br-card">
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-10 col-lg-2 mt-2 br-datetimepicker br-input" [ngClass]="(!parcela.dataInicio && submetido) || parcela.validacao.sobreposto || parcela.validacao.foraOrdem ? 'danger' : ''">
                        <label [for]="'campo-data-inicio_' + i">Data de início (Obrigatório)</label>
                        <br />
                        <p-calendar [inputId]="'campo-data-inicio_' + i" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [(ngModel)]="parcela.dataInicio" [minDate]="dataMinimaParcela" [maxDate]="dataMaximaParcela" [defaultDate]="dataMinimaParcela" [showOtherMonths]="false" (onSelect)="dataInicioChange(parcela)" (onInput)="inputDataInicioChange(parcela, $event)" (onBlur)="blurDataInicioChange(parcela, $event)"></p-calendar>
                        <p class="mt-1" *ngIf="(parcela.dataInicio || !submetido) && parcela.validacao.sobreposto">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                {{ msgParcelasSobrepostas }}
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="(parcela.dataInicio || !submetido) && parcela.validacao.foraOrdem">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                {{ msgParcelasForaDeOrdem }}
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="!parcela.dataInicio && submetido">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                    </div>
                    <div class="col-2 mt-2 text-right mobile-only">
                        <p-button class="p-element" *ngIf="parcelasFerias.length > 1" styleClass="m-2 circle" icon="fas fa-trash-alt" (click)="excluirParcela(parcela)" title="Excluir Parcela"></p-button>
                    </div>
                    <div class="col-12 col-lg-3 mt-2 br-input" [ngClass]="(!parcela.quantidadeDias && submetido) || alocacaoSaldoDiasIncompleta || parcela.validacao.quantidadeDiasIgualZero ? 'danger' : ''">
                        <label [for]="'campo-quantidade-dias_' + i">Quantidade de dias (Obrigatório)</label>
                        <input [id]="'campo-quantidade-dias_' + i" pInputText mask="00" maxlength="2" [(ngModel)]="parcela.quantidadeDias" (change)="quantidadeDiasChange(parcela)" />
                        <p class="mt-1" *ngIf="(parcela.quantidadeDias === 0 || !submetido) && parcela.validacao.quantidadeDiasIgualZero">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                {{ msgQuantidadeDiasIgualZero }}
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="(parcela.quantidadeDias || !submetido) && alocacaoSaldoDiasIncompleta">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                {{ msgAlocacaoSaldoDiasIncompleta }}
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="!parcela.quantidadeDias && parcela.quantidadeDias !== 0 && submetido">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-periodo-ferias_' + i">Data de Término</label>
                        <p class="mb-0" [id]="'campo-periodo-ferias_' + i">
                            {{ parcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only" [style.visibility]="parcela.situacao.descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                    <div class="col-lg-3 mt-2 text-right desktop-only">
                        <p-button class="p-element" *ngIf="parcelasFerias.length > 1" styleClass="m-2 circle" icon="fas fa-trash-alt" (click)="confirmarExclusaoParcela(parcela)" title="Excluir Parcela"></p-button>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px; padding-bottom: 10px" *ngIf="!alocacaoSaldoDiasIncompleta && parcela.validacao.dataInvalida">
                    <div class="col-12 col-lg-12 mt-2">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            Data inválida!
                        </span>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px; padding-bottom: 10px" *ngIf="!alocacaoSaldoDiasIncompleta && parcela.validacao.foraJanelaProgramacao">
                    <div class="col-12 col-lg-12 mt-2">
                        <span class="feedback danger" role="alert" *ngIf="regimeCeletistaOuAnistiado">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgCeletistaAnistiadoComParcelaForaPeriodoProgramacao }}
                        </span>
                        <span class="feedback danger" role="alert" *ngIf="!regimeCeletistaOuAnistiado">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao }}
                        </span>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <p class="label mb-1">Adicionais de Férias</p>
                        <div class="d-flex align-items-center">
                            <p-checkbox [binary]="true" label="Adiantamento 13º" [(ngModel)]="parcela.adiantamentoDecimoTerceiro.valor" [disabled]="parcela.adiantamentoDecimoTerceiro.selecaoDesabilitada" (onChange)="adiantamentoDecimoTerceiroChange(parcela)">
                                <ng-template pTemplate="icon">
                                    <span class="fas fa-check"></span>
                                </ng-template>
                            </p-checkbox>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" pTooltip="O adiantamento deve ser solicitado em única parcela que inicie até 30/jun do ano de exercício das férias."></i>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" pTooltip="O adiantamento deve ser solicitado em única parcela que inicie até 30/jun do ano de exercício das férias." tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="exercicioSelecionado.parametrosFeriasOrgao.pagamentoNoAdiantamento">
                            <p-checkbox [binary]="true" label="Adiantamento Salarial" [(ngModel)]="parcela.adiantamentoSalarial.valor" [disabled]="parcela.adiantamentoSalarial.selecaoDesabilitada" (onChange)="adiantamentoSalarialChange(parcela)">
                                <ng-template pTemplate="icon">
                                    <span class="fas fa-check"></span>
                                </ng-template>
                            </p-checkbox>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" pTooltip="O desconto  ocorrerá em parcela única na remuneração do mês posterior ao das férias."></i>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" pTooltip="O desconto  ocorrerá em parcela única na remuneração do mês posterior ao das férias." tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="exercicioSelecionado.parametrosFeriasCargo.permiteAbonoPecuniario">
                            <p-checkbox [binary]="true" label="Abono Pecuniário" [(ngModel)]="parcela.abonoPecuniario.valor" [disabled]="parcela.abonoPecuniario.selecaoDesabilitada" (onChange)="abonoPecuniarioChange(parcela)">
                                <ng-template pTemplate="icon">
                                    <span class="fas fa-check"></span>
                                </ng-template>
                            </p-checkbox>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" [pTooltip]="'O abono exige no mínimo parcela de ' + qtdDiasMinimoParaAbono + ' dias de férias.'"></i>
                            <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" [pTooltip]="'O abono exige no mínimo parcela de ' + qtdDiasMinimoParaAbono + ' dias de férias.'" tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial.valor">
                        <p class="label mb-1">Parcelas de Desconto</p>
                        <p-dropdown [options]="opcoesParcelasDesconto" (keydown)="$event.stopPropagation()" [removeClearButton]="true" styleClass="mb-1" [overlayOptions]="{ appendTo: 'body' }" [disabled]="opcoesParcelasDesconto.length === 1" [(ngModel)]="parcela.parcelasDesconto" (onChange)="parcelasDescontoChange()">
                            <ng-template pTemplate="dropdownicon">
                                <span class="fas fa-chevron-down"></span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2" [style.visibility]="parcela.situacao.descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="padding-bottom: 10px">
                    <!--padding-bottom-->
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row">
    <div class="col-12 mt-2">
        <label for="aviso">Aviso</label>
        <p id="aviso">A Programação de férias deve ser feita no SouGov pelo agente público e homologada pela chefia. A Gestão de Pessoas atua apenas em casos excepcionais e justificados.</p>
    </div>
</div>
<div class="br-textarea" [ngClass]="{ danger: justificativaInvalida }">
    <label for="textarea-id8">Justificativa de programação pela gestão de pessoas (Obrigatório)</label>
    <textarea id="textarea-id8" class="mt-1" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" [(ngModel)]="justificativaParaAgendarFerias" maxlength="300" (input)="onJustificativaChange($event)" (blur)="validarJustificativa()"></textarea>
    <div class="text-base mt-1">
        <span class="limit" aria-live="polite">
            <b>{{ justificativaParaAgendarFerias.length }}</b>
            de
            <b>300</b>
            caracteres digitados
        </span>
        <span class="current" aria-live="polite" role="status" id="limitmax"></span>
    </div>
    <p class="mt-1" *ngIf="justificativaInvalida">
        <span class="feedback danger" role="alert">
            <i class="fas fa-times-circle" aria-hidden="true"></i>
            {{ msgJustificativaObrigatoria }}
        </span>
    </p>
</div>

<div class="row mt-2">
    <div class="col text-right">
        <button aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="secondary mr-2 botao-responsivo" (click)="confirmarVoltar()"></button>
        <button aria-label="botão programar" id="botao-programar" pButton type="submit" label="Programar" class="primary botao-responsivo" (click)="confirmarProgramacao()"></button>
    </div>
</div>
<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
